
import Head from 'next/head'

import { BaseLayout } from '~/src/components/shared/layout'
import { FilterSection, FestivalList } from '~/src/components/festival'
import { FestivalsContextProvider, FestivalsContext } from '~/src/contexts'
import { getTitle } from '~/src/utils'

export default function FestivalsPage() {
  return (
    <BaseLayout>
      <Head>
        <title>{getTitle('FESTIVALS')}</title>
      </Head>
      <FestivalsContextProvider>
        <FilterSection />
        <FestivalsContext.Consumer>
          {
            ({ loading }) => loading ? null: (
              <FestivalList />
            )
          }
        </FestivalsContext.Consumer>
      </FestivalsContextProvider>
    </BaseLayout>
  )
}
